module.exports = __webpack_public_path__ + "static/pic03-3226b5e037cf7ecdc677d2ff30b814a5.jpg";